export enum Subject {
  MATH = 'math',
  BIOLOGY = 'biology',
  CHEMISTRY = 'chemistry',
  ECONOMY = 'economy',
  FINANCE = 'finance',
  PHYSICS = 'physics',
  STATISTICS = 'statistics',
  OTHER_SUBJECTS = 'other-subjects',
}

export enum TutorOnDemandLandingPage {
  TITLE = 'title',
  PRODUCT_CARD_SLIDER = 'product-card-slider',
  SUPPORT = 'support',
  TESTIMONIALS = 'testimonials',
  PRODUCT_CARD_BUTTON = 'product-card-button',
  WHY_CHOOSE_HOUSE_OF_MATH = 'why-choose-house-of-math',
  COMPETENCY_REQUIREMENT = 'competency-requirements',
  PRICE_LIST = 'price-list',
  MORE_INFORMATION = 'more-information',
  IMAGE = 'image',
}

export const pageComponent = [
  {
    id: TutorOnDemandLandingPage.TITLE,
  },
  {
    id: TutorOnDemandLandingPage.PRODUCT_CARD_SLIDER,
  },
  {
    id: TutorOnDemandLandingPage.SUPPORT,
  },
  {
    id: TutorOnDemandLandingPage.TESTIMONIALS,
  },
  {
    id: TutorOnDemandLandingPage.PRODUCT_CARD_BUTTON,
  },
  {
    id: TutorOnDemandLandingPage.WHY_CHOOSE_HOUSE_OF_MATH,
  },
  {
    id: TutorOnDemandLandingPage.COMPETENCY_REQUIREMENT,
  },
  {
    id: TutorOnDemandLandingPage.PRODUCT_CARD_BUTTON,
  },
  {
    id: TutorOnDemandLandingPage.PRICE_LIST,
  },
  {
    id: TutorOnDemandLandingPage.IMAGE,
  },
  {
    id: TutorOnDemandLandingPage.SUPPORT,
    showAvatar: true,
  },
  {
    id: TutorOnDemandLandingPage.MORE_INFORMATION,
  },
]
